import { type BoxApiGateway } from "@modules/box/services/boxApi.gateway"
import { LoggerService } from "@modules/common/logger/loggerService"
import {
  type BoxDetailDto,
  BoxDetailDtoSchema,
  type BoxItemDto,
  BoxItemDtoSchema,
  type BoxSettingsInputDto,
  BoxSettingsInputDtoSchema,
  type BoxSettingsWaiverDto,
  BoxSettingsWaiverDtoSchema,
  type WebBoxInputDto,
  WebBoxInputDtoSchema,
} from "@modules/box/services/boxDto"
import { ApiClient } from "@modules/core/api/client/apiClient"

export class BoxApi implements BoxApiGateway {
  private baseUrl = "/boxes"

  constructor(private api: ApiClient) {}

  async getBoxs() {
    const resultDto = await this.api.get<BoxItemDto[]>(`${this.baseUrl}`)
    return resultDto.data.map((item) => LoggerService.parseApiDto(BoxItemDtoSchema, item))
  }

  async getBox(id: string) {
    const resultDto = await this.api.get<BoxDetailDto>(`${this.baseUrl}/${id}`)
    return LoggerService.parseApiDto(BoxDetailDtoSchema, resultDto.data)
  }

  async createBox(box: WebBoxInputDto) {
    const resultDto = await this.api.post<BoxDetailDto>(
      `${this.baseUrl}`,
      LoggerService.parseApiDto(WebBoxInputDtoSchema, box),
    )

    return LoggerService.parseApiDto(BoxDetailDtoSchema, resultDto.data)
  }

  async updateBox(id: string, box: WebBoxInputDto) {
    const resultDto = await this.api.put<BoxDetailDto>(
      `${this.baseUrl}/${id}`,
      LoggerService.parseApiDto(WebBoxInputDtoSchema, box),
    )
    return LoggerService.parseApiDto(BoxDetailDtoSchema, resultDto.data)
  }

  async deleteBox(id: string) {
    await this.api.delete<BoxDetailDto>(`${this.baseUrl}/${id}`)
  }

  async updateBoxSettings(id: string, boxSettingsDto: BoxSettingsInputDto) {
    const resultDto = await this.api.put<BoxDetailDto>(
      `${this.baseUrl}/${id}/settings`,
      LoggerService.parseApiDto(BoxSettingsInputDtoSchema, boxSettingsDto),
    )
    return LoggerService.parseApiDto(BoxDetailDtoSchema, resultDto.data)
  }

  async updateBoxWaiver(id: string, waiver: BoxSettingsWaiverDto) {
    const resultDto = await this.api.put<BoxDetailDto>(
      `${this.baseUrl}/${id}/waiver`,
      waiver ? LoggerService.parseApiDto(BoxSettingsWaiverDtoSchema, waiver) : undefined,
    )
    return LoggerService.parseApiDto(BoxDetailDtoSchema, resultDto.data)
  }
}
